import React from "react"
import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"
import { projectIdState } from "../StateSelectors"
import { track } from "../../util/gainsight"

interface OopsProps {
  heading?: string
  body?: React.ReactNode
  requestId?: string
  tryAgainDisabled?: boolean
  isAuthError?: boolean
}

const RequestInfo = (requestId: string) => (
  <div className="d-flex justify-content-center align-items-center">
    <span className="bg-gray_2">{requestId}</span>
    <button className="button link-secondary" onClick={() => navigator.clipboard.writeText(requestId)}>
      <i className="icon-font i16 tc-icon-file-copy"></i>
    </button>
  </div>
)

const Oops = (props: OopsProps) => {
  const { t } = useTranslation("common")
  const connectProjectId = useRecoilValue(projectIdState)
  const track_event = props.isAuthError ? "unauthorized_" : "error_"
  track(track_event + "page_view", { connectProjectId: connectProjectId })

  return (
    <div className="d-flex flex-column" style={{ height: "100%" }}>
      <div className="row align-items-start ">
        <div className="col d-flex justify-content-start my-1">
          <img src="Quadri_24_gray.svg" height={24} width={24} alt={t("sharedObjectModel")} className="mx-1" />
          <h3>{t("sharedObjectModel")}</h3>
        </div>
      </div>
      <div className="d-flex h-100 flex-column justify-content-center align-items-center text-center text-muted align-center">
        <div
          className="bg-gray_0 d-block rounded d-flex justify-content-center align-items-center mb-1"
          style={{ width: "192px", height: "192px" }}
        >
          <i
            data-testid="error-icon"
            className={`icon-font i64 ${props.isAuthError ? "tc-icon-folder-locked" : "tc-icon-error-alt"} `}
          ></i>
        </div>
        <h1 className="mb-1" style={{ maxWidth: "800px" }}>
          {props.heading || "Oops!"}
        </h1>
        {props.body ? (
          <>
            <p style={{ maxWidth: "800px" }}>{props.body}</p>
            {props.requestId ? RequestInfo(props.requestId) : ""}
          </>
        ) : (
          <>
            <p>It seems like an we've experienced an issue</p>
            <p className="mt-1">Please try again at a later time...</p>
          </>
        )}
        <br />
        {!props.tryAgainDisabled && (
          <button
            className="button primary"
            onClick={() => {
              track(track_event + "try_again", { connectProjectId: connectProjectId })
              localStorage.clear()
              window.location.reload()
            }}
          >
            {t("tryAgain")}
          </button>
        )}
      </div>
    </div>
  )
}

export default Oops
